<template>
  <!-- Main -->
  <div id="main">
    <!-- 串接 -->
    <div id="mainApi">

      <div class="areaH">
        <div class="areaV">
          <div class="box">
            <span class="title">接單平台</span>
            <div class="item" style="justify-content: space-between;">
              <div class="item" style="width: 100%; flex-wrap:wrap;">
                <div class="api" v-for="(app, index) in takeOrderPlatform" :key="'app' + index" @click="clickApp(app)"
                  style="cursor: pointer;">
                  <div class="switch-container" v-if="typeof app.enable === 'boolean'">
                    <label class="switch" @click.stop="">
                      <input type="checkbox" v-model="app.enable" @change="switchChange(app)" checked>
                      <span class="slider round"></span>
                    </label>
                  </div>
                  <div class="cover" v-if="!app.active">
                    <span>未開通</span>
                  </div>
                  <div class="logo">
                    <img :src="app.img">
                    <span>{{ app.displayName }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="areaH">
        <div class="areaV">
          <div class="box">
            <span class="title">加值服務</span>
            <div class="item" style="justify-content: space-between;">
              <div class="item" style="width: 100%; flex-wrap:wrap;">
                <div class="api" v-for="(app, index) in additionServices" :key="'app' + index" @click="clickApp(app)"
                  style="cursor: pointer;">
                  <div class="switch-container" v-if="typeof app.enable === 'boolean'">
                    <label class="switch" @click.stop="">
                      <input type="checkbox" v-model="app.enable" @change="switchChange(app)" checked>
                      <span class="slider round"></span>
                    </label>
                  </div>
                  <div class="cover" v-if="!app.active">
                    <span>未開通</span>
                  </div>
                  <div class="logo">
                    <img :src="app.img">
                    <span>{{ app.displayName }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="areaH">
        <div class="areaV">
          <div class="box">
            <span class="title">POS串接</span>
            <div class="item" style="justify-content: space-between;">
              <div class="item" style="width: 100%; flex-wrap:wrap;">
                <div class="api" v-for="(app, index) in pos" :key="'app' + index" @click="clickApp(app)"
                  style="cursor: pointer;">
                  <div class="switch-container" v-if="typeof app.enable === 'boolean'">
                    <label class="switch" @click.stop="">
                      <input type="checkbox" v-model="app.enable" @change="switchChange(app)" checked>
                      <span class="slider round"></span>
                    </label>
                  </div>
                  <div class="cover" v-if="!app.active">
                    <span>未開通</span>
                  </div>
                  <div class="logo">
                    <img :src="app.img">
                    <span>{{ app.displayName }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- TTPush Popup -->
      <div id="popTTpush" class="modal" v-if="tempApp.isSetting && tempApp.app.popType === 'ttpush'">
        <div class="modal-content">
          <span class="close" @click="settingCancelled()">&times;</span>
          <span class="title" style="margin-bottom: 0;">{{ tempApp.app.displayName }}</span>
          <div id="main" style="margin-bottom: 0;">
            <div class="areaH">
              <div class="areaV">
                <ul class="content" style="padding-left: 20px;">
                  <li>服務已啟用</li>
                  <li v-if="tempApp.app.vendorCode === 'ttpush'">設定ID：{{ tempApp.app.merchantId }}</li>
                  <li v-else>17Life商店ID：{{ tempApp.app.life17StoreId }}</li>
                  <li>啟用時間：{{ tempApp.app.createdAt }}</li>
                </ul>
                <span class="remark" style="margin: 5px 0;">請將下方網址設定到{{ tempApp.app.vendorCode === 'ttpush' ? 'TTPush後台'
                    :
                    'Richmenu寄杯券購買按鈕'
                }}</span>
                <div class="item">
                  <input class="input" type="text" id="copy-TTpushUrl" placeholder="" :value="tempApp.app.url" disabled>
                  <a class="copy" @click="copyLink('copy-TTpushUrl')">
                    <FontAwesomeIcon class="fas fa-copy" icon="copy" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 計杯 Popup -->
      <div id="popCup" class="modal" v-if="tempApp.isSetting && tempApp.app.popType === 'cup'">
        <div class="modal-content">
          <span class="close" @click="settingCancelled()">&times;</span>
          <span class="title" style="margin-bottom: 0;">寄杯券服務串接</span>
          <div id="main">
            <div class="areaH">
              <div class="areaV">
                <div class="item">
                  <input class="input" type="text" id="copy-life17ShoppingUrl" placeholder=""
                    :value="tempApp.app.life17ShoppingUrl" disabled>
                  <a class="copy" @click="copyLink('copy-life17ShoppingUrl')">
                    <FontAwesomeIcon class="fas fa-copy" icon="copy" />
                  </a>
                </div>
                <span class="remark" style="margin: 5px 0;">請將上方網址建立成LIFF ID後，填入下方欄位後啟用服務</span>
                <div class="item">
                  <input class="input" type="text" placeholder="LIFFID" v-model="tempApp.app.liffId">
                </div>
              </div>
            </div>
          </div>
          <a class="button submit" @click="appAction()">啟用17Life寄杯券服務</a>
        </div>
      </div>

      <!-- APP串接網址 Popup -->
      <div id="popApp" class="modal" v-if="tempApp.isSetting && tempApp.app.popType === 'app'">
        <div class="modal-content">
          <span class="close" @click="settingCancelled()">&times;</span>
          <span class="title" style="margin-bottom: 0;">APP串接網址</span>
          <div id="main" style="margin-bottom: 0;">
            <div class="areaH">
              <div class="areaV">
                <span class="remark" style="margin: 5px 0;">WEMO</span>
                <div class="item">
                  <input class="input" type="text" id="copy-wemoUrl" placeholder="" :value="tempApp.app.url" disabled>
                  <a class="copy" @click="copyLink('copy-wemoUrl')">
                    <FontAwesomeIcon class="fas fa-copy" icon="copy" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- popup -->
      <div id="popApi" class="modal" v-if="tempApp.isSetting && tempApp.app.popType === 'default'">
        <div class="modal-content" style="width: 400px">
          <span class="close" @click="settingCancelled()">&times;</span>
          <div class="item">
            <img class="titleImg" :src="tempApp.app.img" />
            <span class="title">{{ tempApp.app.displayName }}</span>
          </div>
          <div id="main">
            <div class="areaH">
              <div class="areaV">
                <div class="item" v-for="(entry, keyName) in tempApp.app.entrys" :key="keyName" style="height: 40px">
                  <div style="display: flex; flex-direction: column">
                    <span class="content" style="min-width: 100px">{{
                        keyName
                    }}</span>
                    <span v-if="entry.ps" class="remark" style="margin-top: -5px">{{ entry.ps }}</span>
                  </div>

                  <label v-if="entry.type === 'switch'" class="switch" style="margin-left: 10px">
                    <input v-model="entry.value" type="checkbox" @change="switchEntryChange(keyName)" checked />
                    <span class="slider round"></span>
                  </label>
                  <input v-else-if="entry.type === 'input'" v-model="entry.value" class="input" type="text"
                    style="margin-left: 10px" placeholder="" :disabled="entry.disabled" />
                  <label v-else-if="entry.type === 'checkbox'" class="check" style="margin-left: 10px">
                    <input v-model="entry.value" type="checkbox" name="checkbox1" :disabled="entry.disabled" />
                    <span class="checkmark checkbox"></span>
                    <div class="text">{{ entry.text || '使用點點預設帳號' }}</div>
                  </label>
                  <div class="tabs" style="width: 94px; margin-left: 10px" v-else-if="entry.type === 'tabs'">
                    <a v-for="option in entry.tabOptions" :key="option.value" :class="
                      entry.value === option.value ? 'tab active' : 'tab'
                    " @click="tabClick(entry, option)">
                      <span>{{ option.label }}</span>
                    </a>
                  </div>
                  <select v-else-if="entry.type === 'select'" v-model="entry.value" class="input"
                    style="margin-left: 10px" :disabled="entry.disabled">
                    <option v-for="opt in entry.options" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <a class="button delete" v-if="tempApp.app.buttons.delete" @click="popDelete(tempApp.app.id)">
              <span class="remark">刪除</span>
            </a>
            <a class="button cancel" @click="settingCancelled()">取消</a>
            <a class="button submit" @click="appAction()">更新</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  fetchMWSetting,
  fetchServices,
  fetchServiceUrls,
  fetchMWActive,
  fetchPosDvrSetting,
  fetchCounterUsers
} from "src/javascripts/gaa/fetchData";
import {
  App,
  UbereatsPro,
  FoodpandaPro,
  UberEatsLite,
  FoodpandaLite,
  LineSpot,
  Gofoodie,
  Idoo,
  Lafresh,
  Geoshop,
  TTpush,
  Life17,
  AppWeb,
  PosDvr,
  Tyc,
  Dudoo,
  Kiosk,
  DongDong,
  DongDongKiosk,
  // KabobTico
} from "src/pages/Stores/Gaa/AccountSetting/other.js";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import swal from "sweetalert2";
import {
  removePosmw
} from "src/javascripts/generalPages/deleteData";

export default {
  components: {
    FontAwesomeIcon
  },

  props: {
    accountId: {
      type: Number,
      default: 1,
    },
    shopId: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      tempApp: {
        isSetting: false,
        app: new App(),
      },
      apps: [],
      takeOrderPlatform: [],
      additionServices: [],
      pos: []
    };
  },
  computed: {
    type() {
      return this.$route.params.type || 'gaa';
    }
  },
  created: async function () {
    this.refresh()
  },

  methods: {
    async refresh() {
      this.initial();
      await Promise.all([this.getPosMw(), this.getServices(), this.getActive(), this.getPosDvrService()]);
    },
    initial() {
      this.apps = [
        new UbereatsPro(),
        new FoodpandaPro(this.accountId),
        new UberEatsLite(),
        new FoodpandaLite(this.accountId),
        new LineSpot(this.accountId),
        new Gofoodie(),
        new Idoo(this.accountId),
        new Lafresh(),
        new Geoshop(),
        new TTpush(),
        new Life17(),
        new AppWeb(),
        new PosDvr(this.accountId),
        new Tyc(),
        new Dudoo(),
        new Kiosk(this.accountId, this.shopId),
        new DongDong(this.accountId, this.shopId),
        //new DongDongKiosk(this.accountId, this.shopId)
        // new KabobTico()
      ];
      this.takeOrderPlatform = this.apps.filter(app => app.appType === 'takeOrderPlatform');
      this.additionServices = this.apps.filter(app => app.appType === 'additionServices');
      this.pos = this.apps.filter(app => app.appType === 'pos');
    },
    getPosMw() {
      // 取得 posmw table 的資料
      return fetchMWSetting(this.accountId)
        .then((response) => {
          const rows = response.data;

          for (const row of rows) {
            const app = this.findApp('vendorCode', row.vendorCode);
            if (app) app.setData(row);
          }
        }).catch((err) => {
          console.log(err);
          this.$message({
            message: "posmw資料取得失敗",
            type: "error",
          });
        });
    },
    getServices() {
      // 取得 services 的資料
      return Promise.all([
        fetchServices(this.accountId),
        fetchServiceUrls(this.accountId),

      ]).then(([servicesRes, urlsRes]) => {
        const services = servicesRes.data;
        const serviceUrl = urlsRes.data;

        for (const serviceKey in services) {
          const app = this.findApp('vendorCode', serviceKey);

          if (app) app.setData(services[serviceKey], serviceUrl);
        }

        const webApp = this.findApp('vendorCode', 'app');
        if (webApp) webApp.setData(undefined, serviceUrl);

      }).catch((err) => {
        console.log(err);
        this.$message({
          message: "services資料取得失敗",
          type: "error",
        });
      });
    },
    getActive() {
      return fetchMWActive(this.accountId)
        .then(response => {
          const activeList = response.data;

          for (const activeVendorCode of activeList) {
            const app = this.findApp('vendorCode', activeVendorCode);
            if (app) app.setActive(true);
          }

        }).catch((err) => {
          console.log(err);
          this.$message({
            message: "unactive資料取得失敗",
            type: "error",
          });
        });
    },
    getPosDvrService() {
      // 取得 posdvr 的資料
      return Promise.all([
        fetchPosDvrSetting(this.accountId)

      ]).then(([posdvrRes]) => {
        const posdvr = posdvrRes.data;

        console.log('FetchposdvrSetting: ', posdvr);  

        const webApp = this.findApp('vendorCode', 'posdvr');
        console.log('Web App: ', webApp);
        if (webApp) webApp.setData(posdvr);

      }).catch((err) => {
        console.log(err);
        this.$message({
          message: "services資料取得失敗",
          type: "error",
        });
      });
    },
    async clickApp(app) {
      // 點集任一個 app，copy data 到 tempApp.app
      this.tempApp.app = app.copy();
      this.tempApp.isSetting = true;
      // QC-3316: iDOO(counter)卡片開啟時,載入該店接單機帳號填「管理員帳號」下拉
      if (app.vendorCode === 'counter' && this.tempApp.app.entrys['管理員帳號']) {
        // 一律先放「無」選項,即使 API 失敗下拉仍可用
        const options = [{ label: '無(不需管理員驗證)', value: '' }];
        try {
          const res = await fetchCounterUsers(this.accountId);
          const users = (res && res.data) ? res.data : [];
          for (const u of users) {
            options.push({ label: u.username, value: String(u.id) });
          }
        } catch (err) {
          console.log('counter-users 載入失敗', err);
        }
        this.tempApp.app.entrys['管理員帳號'].options = options;
      }
    },
    settingCancelled() {
      // 取消編輯，initall tempApp
      this.tempApp = {
        isSetting: false,
        app: new App(),
      };
    },
    tabClick(entry, option) {
      if (entry.value === option.value) entry.value = undefined;
      else entry.value = option.value;
    },
    copyLink(id) {
      // 複製連結
      let urlElement = document.querySelector(`#${id}`);
      urlElement.removeAttribute('disabled')
      urlElement.select();
      let copySuccess = document.execCommand("copy");

      if (copySuccess) {
        this.$message({
          type: 'success',
          message: `已複製`
        });
      } else {
        this.$message({
          type: 'error',
          message: `錯誤`
        });
      }
      urlElement.setAttribute('disabled', '');
    },
    appAction() {
      try {
        this.tempApp.app.action(this.accountId)
          .then(success => {
            this.$message({
              type: 'success',
              message: '更新成功'
            });
            this.settingCancelled();
            this.refresh();
          }).catch(error => {
            console.log(error);
            this.$message({
              type: 'error',
              message: '更新失敗'
            });
          })

      } catch (error) {
        console.log(error);
        this.$message({
          type: 'error',
          message: error
        });
      }
    },
    switchChange(app) {
      
      try {
        app.action(this.accountId)
        .then(success => {
          this.$message({
            type: 'success',
            message: '更新成功'
          });
          this.refresh();
        }).catch(error => {
          this.$message({
            type: 'error', 
            message: '更新失敗'
          });
          this.refresh();
        })
      } catch (e) {
        
        this.$message({
          type: 'error', 
          message: '更新失敗'
        });
      }
     
      
    },
    switchEntryChange(key) {
      if (!this.tempApp.app.switchEntryOnChange) return;

      this.tempApp.app.switchEntryOnChange(key, this.accountId)
        .then(success => {
          this.$message({
            type: 'success',
            message: '設定成功'
          })
          this.refresh();
          this.settingCancelled();
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: '設定失敗'
          })
        })
    },
    findApp(key, value) {
      for (const app of this.apps) {
        if (app[key] === value) return app;
      }
      return null;
    },
    popDelete(id) {
      if (!id) {
        this.$message({
          type: 'error',
          message: '刪除失敗'
        });
        return;
      }
      swal.fire({
        title: `確認刪除`,
        text: `刪除後將無法還原`,
        buttonsStyling: true,
        showCancelButton: true,
        confirmButtonColor: "#f96332",
        cancelButtonColor: "#cccccc",
        confirmButtonText: "刪除",
        cancelButtonText: "取消"
      }).then(res => {
        if (res.value) {
          // delete
          removePosmw(this.accountId, id, this.type)
          .then(res => {
            this.$message({
              type: 'success',
              message: '刪除設定成功'
            });
            // 關閉編輯視窗 & 取得新設定，initall tempApp
            this.settingCancelled();
            this.refresh();
          })
          .catch(err => {
            this.$message({
              type: 'error',
              message: '刪除設定失敗'
            });
          })
        }
      });
    }
  }
};
</script>
<style scoped src="../../../../../src/assets/css/shop-console.css">

</style>

<style scoped>
.switch-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
